import type { BlogAuthorSlug } from "./types"

/** Matches landing `Team` section (`/img/team/*`). */
export const BLOG_AUTHORS: Record<
  BlogAuthorSlug,
  {
    name: string
    role: string
    photo_url: string
    /** LinkedIn etc. for JSON-LD `Person.sameAs` — aligned with `app/src/landing/landing.tsx` Team. */
    same_as: string[]
  }
> = {
  nat: {
    name: "Nat Noone",
    role: "Cofounder",
    photo_url: "/img/team/nat.png",
    same_as: ["https://www.linkedin.com/in/nat-noone-3211997/"],
  },
  joey: {
    name: "Joey Caffrey",
    role: "CEO",
    photo_url: "/img/team/joey.webp",
    same_as: ["https://www.linkedin.com/in/joey-caffrey-58155687/"],
  },
}

export function resolve_blog_author(slug: string | null | undefined): (typeof BLOG_AUTHORS)[BlogAuthorSlug] {
  if (slug === "nat" || slug === "joey") {
    return BLOG_AUTHORS[slug]
  }
  return BLOG_AUTHORS.nat
}
